import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { ScreenSizeService } from '../services/screen-size.service';

@Directive({
  selector: '[screenSize]'
})
export class ScreenSizeDirective implements OnInit {
  LARGE = '(min-width: 1360px)';
  MIDDLE = '(min-width: 1024px) and (max-width: 1360px)';
  SMALL = '(max-width: 1024px)';

  allSizes: Array<any>;

  constructor(private el: ElementRef, private screenSizeService: ScreenSizeService) {
    this.allSizes = this.screenSizeService.getAllSizes();
  }

  ngOnInit() {
    this.checkSize();
    this.screenSizeService.setClientWidth(window.innerWidth);
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.screenSizeService.setClientWidth(event.target.innerWidth);
    this.checkSize();
  }

  checkSize() {
    const isLarge = window.matchMedia(this.LARGE);
    const isMiddle = window.matchMedia(this.MIDDLE);
    const isSmall = window.matchMedia(this.SMALL);

    this.el.nativeElement.classList.remove('screen-lg', 'screen-md', 'screen-sm');


    if (isLarge.matches) {
      this.screenSizeService.setSize(this.allSizes[2]);
      this.el.nativeElement.className = 'screen-lg';
    } else if (isMiddle.matches) {
      this.screenSizeService.setSize(this.allSizes[1]);
      this.el.nativeElement.className = 'screen-lg screen-md';
    } else {
      this.screenSizeService.setSize(this.allSizes[0]);
      this.el.nativeElement.className = 'screen-lg screen-md screen-sm';
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/directives/screen-size.directive.ts